import React, { useState } from "react";
import {
  Button,
  Menu,
  Dialog,
  DialogTitle,
  DialogActions,
  Box,
  ListItemButton,
  List,
  ListItemText,
  TextField,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";

const WEB_EMM_OPTIONS = [
  { label: "Refresh", value: "loadStartUrl" },
  { label: "Get Screenshot", value: "getScreenshot" },
  { label: "Get Device Info", value: "getDeviceInfo" },
  { label: "Restart Application", value: "restartApp", isDanger: true },
  { label: "Reboot Device", value: "rebootDevice", isDanger: true },
];

const NATIVE_EMM_OPTIONS = [
  { label: "Refresh", value: "REFRESH_APP" },
  { label: "Get Logs", value: "GET_LOGS" },
  { label: "Get Screenshot", value: "SCREENSHOT" },
  { label: "Update Application", value: "OTA_UPDATE", needsInput: true }, // ✅ NEW
  { label: "Restart Application", value: "RESTART_APP", isDanger: true },
  { label: "Reboot Device", value: "REBOOT_DEVICE", isDanger: true },
];

const EmmActionMenu = ({ row, onAction }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null);
  const [inputAction, setInputAction] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const emmConfig = useSelector((state) => state?.emmConfig?.emmConfig);

  const isNative = emmConfig?.[row.id]?.native === true;
  const EMM_OPTIONS = isNative ? NATIVE_EMM_OPTIONS : WEB_EMM_OPTIONS;

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleOptionClick = (option) => {
    handleMenuClose();

    if (option.needsInput) {
      setInputAction(option);
    } else if (option.isDanger) {
      setConfirmAction(option);
    } else {
      onAction(row, option.value);
    }
  };

  const handleConfirm = () => {
    onAction(row, confirmAction.value);
    setConfirmAction(null);
  };

  const handleCancel = () => setConfirmAction(null);

  const handleInputSubmit = () => {
    if (!inputValue) return;

    // ✅ URL validation
    try {
      new URL(inputValue);
    } catch {
      alert("Invalid URL");
      return;
    }

    const command = `${inputAction.value}->${inputValue}`;
    onAction(row, command);

    setInputAction(null);
    setInputValue("");
  };

  const chipStyle = {
    padding: "4px 12px",
    fontWeight: 100,
    fontSize: "0.75rem",
  };

  return (
    <>
      {/* 🔽 Button */}
      <Button
        variant="outlined"
        endIcon={<ArrowDropDownIcon />}
        onClick={handleMenuOpen}
        color="success"
      >
        EMM
      </Button>

      {/* 📋 Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <List>
          {EMM_OPTIONS.map((option) => (
            <ListItemButton
              key={option.value}
              onClick={() => handleOptionClick(option)}
              sx={{
                color: option.isDanger ? "error.main" : "primary.main",
                "&:hover": {
                  cursor: "pointer",
                  transform: "scale(1.03)",
                },
                ...chipStyle,
              }}
            >
              <ListItemText primary={option.label} />
            </ListItemButton>
          ))}
        </List>
      </Menu>

      {/* ⚠️ Confirm Dialog */}
      <Dialog open={!!confirmAction} onClose={handleCancel}>
        <DialogTitle>
          Are you sure you want to {confirmAction?.label} for this device?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleConfirm} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🔗 URL Input Dialog */}
      <Dialog open={!!inputAction} onClose={() => setInputAction(null)}>
        <DialogTitle>
          Enter APK URL for {inputAction?.label}
        </DialogTitle>

        <Box px={3} pb={2}>
          <TextField
            fullWidth
            size="small"
            placeholder="https://example.com/app.apk"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Box>

        <DialogActions>
          <Button onClick={() => setInputAction(null)}>Cancel</Button>
          <Button
            onClick={handleInputSubmit}
            variant="contained"
            disabled={!inputValue}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EmmActionMenu;